export interface RawSseEvent {
	data: string;
	event: string;
}

const stripLeadingSpace = (value: string): string => (value.startsWith(" ") ? value.slice(1) : value);

const parseBlock = (block: string): RawSseEvent | null => {
	let event = "message";
	const dataLines: string[] = [];
	for (const line of block.split("\n")) {
		if (line.length === 0 || line.startsWith(":")) continue;
		if (line.startsWith("event:")) event = line.slice(6).trim();
		else if (line.startsWith("data:")) dataLines.push(stripLeadingSpace(line.slice(5)));
	}
	if (dataLines.length === 0) return null;
	return { data: dataLines.join("\n"), event };
};

const drainSseEvents = (buffer: string): { events: RawSseEvent[]; rest: string } => {
	const normalized = buffer.replace(/\r\n/g, "\n");
	const segments = normalized.split("\n\n");
	const rest = segments.pop() ?? "";
	const events: RawSseEvent[] = [];
	for (const segment of segments) {
		const parsed = parseBlock(segment);
		if (parsed) events.push(parsed);
	}
	return { events, rest };
};

export default drainSseEvents;

export { drainSseEvents };
